import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";
import { Prompt } from "react-router";

import { userActions } from "actions";
import { connect } from "react-redux";

import { USER_TYPE_WORKER, USER_TYPE_CONTREMAITRE, DOCUMENT_TYPE_PHOTO } from "constants/dbValues";
import { Can } from "constants/abilityContext";
import {
  history,
  title,
  isChecked,
  validateProfileFields,
  selectProps,
  displayErrorContext,
} from "utils";

import { Header, DocumentsList } from "components";
import { Icon, Input, InputNumber, notification, Select, Checkbox, Button, Divider, Modal, Spin } from "antd";

import { userService, selectService } from "services";

// Composant de détails d'un modèle.
// Beaucoup d'optimisation possible (React Modeling 04h11 pour code optimisé et centralisé).
//
// Les fonctions suivantes sont implémentées :
// - fetchSelects()
//   Fetch les options des dropdowns avec le selectService.
// - formatTag()
//   Render le html approprié selon les clés données dans le html.
//   En read render du static, en edit ou create render des inputs.
// - handleChange()
//   Gère le changement d'une valeur.
// - handleSubmit()
//   Gère le submit du form, tant en edit qu'en create.
// - validateFields()
//   Valide les champs du form qui sont required, utilise la fonction validateProfileFields
//   de utils/form.
// - render()
//   Render commun pour les 3 modes, la gestion des inputs se fait dans
//   formatTag(), mais les conditions plus générales se font directement dans render()
class UserPage extends Component {
  constructor(props) {
    super(props);

    const { id } = this.props.match.params;

    this.state = {
      user: {
        __type: "User",
        id: id,
        documents: [],
      },
      uploading: false,
      errors: {},
      pwdError: false,
      edited: false,
      types: [],
      jobs: [],

      termsModal: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateFields = this.validateFields.bind(this);
    this.toggleTermsModal = this.toggleTermsModal.bind(this);
  }

  componentDidMount() {
    const { user } = this.state;
    const { edit, create, currentUser } = this.props;

    this.doclist = React.createRef();

    if (!create) {
      userService
        .get(user.id)
        .then((result) => {
          // Gestion de la mise à jour de la photo de profil.
          // Si on edit le user connecté, on unset la photo de profil. La redirection
          // après l'édition nous mène ici, et là on peut set la nouvelle photo.
          if (user.id == currentUser.id && typeof currentUser.document === "undefined") {
            var doc =
              (result.documents || []).filter((d) => d.type_id === DOCUMENT_TYPE_PHOTO) || [];
            doc = doc[doc.length - 1] || {};
            this.props.updateProfilePicture(doc);
          }

          this.setState({ user: { ...user, ...result } });
        })
        .catch((e) => {
          history.push("/users");
        });
    }

    if (edit || create) this.fetchSelects();
  }

  componentWillReceiveProps(nextProps) {
    const { types } = this.state;
    const { edit, create } = nextProps;
    if ((!types || types.length === 0) && (edit || create)) this.fetchSelects();
  }

  async fetchSelects() {
    const selects = await selectService.listForPage("user");

    //Vérifie si powerbi est dans les types utilisateurs pour le retirer
    let index = selects.UserType.findIndex((e) => e.label === "Powerbi");
    if (index !== -1) selects.UserType.splice(index, 1);

    this.setState({ types: selects.UserType, jobs: selects.Job });
  }

  formatTag(key, fixed = false, label = "") {
    const { user, errors } = this.state;
    const { edit, create } = this.props;

    if ((!edit && !create) || (fixed && edit)) {
      switch (key) {
        case "type_id":
          return user.user_type ? (
            <>
              <Icon type="tag" />
              {user.user_type.label}
            </>
          ) : (
            ""
          );
        case "job_id":
          return user.job ? (
            <>
              <Icon type="tool" />
              {user.job.label}
            </>
          ) : (
            ""
          );
        case "disabled":
        case "system_user":
          return isChecked(user[key]) ? label : "";
        default:
          return <b>{user[key]}</b>;
      }
    }

    var input;
    if (key === "disabled" || key === "consent_to_all" || key === "system_user") {
      input = (
        <Checkbox
          name={key}
          checked={isChecked(user[key])}
          onChange={(e) => this.handleChange(e.target.checked, key)}
        >
          {label}
        </Checkbox>
      );
    } else if (key === "type_id" || key === "job_id") {
      var list = [],
        computeLabel = (t) => t.label;
      if (key === "type_id") {
        list = this.state.types;
      }
      if (key === "job_id") {
        list = this.state.jobs;
      }

      var options = list.map((t) => (
        <Select.Option key={t.id} value={t.id}>
          {computeLabel(t)}
        </Select.Option>
      ));

      input = (
        <Select
          value={user[key]}
          onChange={(value) => this.handleChange(value, key)}
          {...selectProps()}
        >
          {options}
        </Select>
      );
    } else if (key === "weeks_worked") {
      input = (
        <InputNumber
          min={1}
          max={52}
          value={user[key] || 52}
          onChange={(value) => this.handleChange(value, key)}
        />
      );
    } else {
      var Tag = key === "password" || key === "password_bis" ? Input.Password : Input;

      input = (
        <Tag
          name={key}
          value={user[key]}
          autoSize={{ minRows: 3, maxRows: 20 }}
          onChange={(e) => this.handleChange(e.target.value, key)}
        />
      );
    }

    var error = errors && errors[key];
    return <span className={error ? "error-wrap" : ""}>{input}</span>;
  }

  handleChange(value, key) {
    this.setState({ user: { ...this.state.user, [key]: value }, edited: true });
  }

  handleSubmit() {
    if (!this.validateFields()) return;

    var user = { ...this.state.user };
    const { edit, create } = this.props;

    var func;
    user.updated_at = new Date();

    user.consent_to_all = user.consent_to_all ? 1 : 0;

    if (edit) {
      func = this.props.update;

      if (!user.password || user.password === "") {
        delete user.password;
      } else if (user.password !== user.password_bis) {
        this.setState({ pwdError: true });
        return;
      }
    } else if (create) {
      func = userService.create;
      user.created_at = new Date();

      if (user.password !== user.password_bis) {
        this.setState({ pwdError: true });
        return;
      }
    }

    delete user.user_type;
    delete user.documents;
    delete user.projects;
    delete user.incidents;

    if (user.type_id != USER_TYPE_WORKER) user.job_id = null;

    const errorNotif = (e) => {
      this.setState({ uploading: false });
      notification.open({
        message: "Une erreur s'est produite",
        description: "Veuillez réessayer ou contacter un administrateur.",
        placement: "bottomRight",
      });
    };

    this.setState({ uploading: true }, () => {
      func(user)
        .then((u) => {
          this.doclist.current
            .executeActions(u.id, "User")
            .then(() => {
              notification.open({
                message: "Enregistrement effectué",
                description: "Vos changements ont été enregistrés avec succès.",
                placement: "bottomRight",
              });

              this.setState({
                user: { ...user, ...u },
                edited: false,
                pwdError: false,
                uploading: false,
              });
              history.replace(`/users/${u.id}`);
            })
            .catch((e) => errorNotif(e));
        })
        .catch((e) => errorNotif(e));
    });
  }

  validateFields() {
    const { user } = this.state;
    const { edit, create } = this.props;

    var fields = ["type_id", "name", "surname", "email", "consent_to_all"];
    if (create) fields.push("password");
    var validation = validateProfileFields(user, fields);

    this.setState({ errors: validation.errors });
    return !validation.hasError;
  }

  toggleTermsModal() {
    this.setState({ termsModal: !this.state.termsModal });
  }

  render() {
    const { user, errors, uploading } = this.state;
    const { edit, create } = this.props;

    var mode = "read",
      pageTitle = "Profil d'un utilisateur",
      header = `Utilisateur #${user.id}`,
      bread = [{ to: "/users", text: "Liste des utilisateurs" }, { text: user.id }];

    if (edit) {
      mode = "edit";
      pageTitle = "Édition d'un utilisateur";
      bread = [
        { to: "/users", text: "Liste des utilisateurs" },
        { to: `/users/${user.id}`, text: user.id },
        { text: "Édition" },
      ];
    } else if (create) {
      mode = "create";
      pageTitle = "Création d'un utilisateur";
      header = "Nouvel utilisateur";
      bread = [{ to: "/users", text: "Liste des utilisateurs" }, { text: "Création" }];
    }

    const isWorker = user.type_id == USER_TYPE_WORKER;
    const isContremaitre = user.type_id == USER_TYPE_CONTREMAITRE;

    return (
      <Fragment>
        <Helmet>{title(pageTitle)}</Helmet>

        <Header title={header} bread={bread} />

        <div className={`user-page main-content profile-content ${mode}`}>
          <Can do={mode} on={user}>
            <Spin
              indicator={<Icon type="loading" spin style={{ fontSize: "52px" }} />}
              spinning={uploading}
            >
              {mode === "read" && (
                <ul className="tags">
                  <li>{this.formatTag("type_id")}</li>
                  {isWorker && <li>{this.formatTag("job_id")}</li>}
                  <li className="alt">{this.formatTag("disabled", false, "Désactivé")}</li>
                </ul>
              )}

              <ul className={"profile-main-content " + mode}>
                {mode !== "read" && (
                  <Can do={"edit_type"} on={user}>
                    <li>
                      <label>Type :</label>
                      {this.formatTag("type_id")}
                    </li>

                    {isWorker && (
                      <li>
                        <label>Travail :</label>
                        {this.formatTag("job_id")}
                      </li>
                    )}
                    <Divider />
                  </Can>
                )}

                <li>
                  <label>Prénom :</label>
                  {this.formatTag("name")}
                </li>

                <li>
                  <label>Nom :</label>
                  {this.formatTag("surname")}
                </li>

                <li>
                  <label>Courriel :</label>
                  {this.formatTag("email")}
                </li>

                {isContremaitre && (
                  <li>
                    <label>Semaines travaillées :</label>
                    {this.formatTag("weeks_worked")}
                  </li>
                )}

                <Divider />

                <li>
                  <label>Addresse :</label>
                  {this.formatTag("address")}
                </li>

                <li>
                  <label>Code postal :</label>
                  {this.formatTag("zipcode")}
                </li>

                <li>
                  <label>Ville :</label>
                  {this.formatTag("city")}
                </li>

                <li>
                  {this.formatTag(
                    "consent_to_all",
                    false,
                    <>
                      Consentement aux <a onClick={this.toggleTermsModal}>termes et conditions</a>
                    </>,
                  )}
                </li>

                {mode !== "read" && (
                  <Fragment>
                    <Divider />
                    <li>
                      <label>{create ? "Mot de passe :" : "Nouveau mot de passe :"}</label>
                      {this.formatTag("password")}
                    </li>

                    <li>
                      <label>Confirmation du mot de passe :</label>
                      {this.formatTag("password_bis")}
                    </li>

                    <Can do="disable" on={user}>
                      <li>{this.formatTag("disabled", false, "Utilisateur désactivé")}</li>
                      <li>{this.formatTag("system_user", false, "Non employé")}</li>
                    </Can>
                  </Fragment>
                )}
              </ul>

              <DocumentsList
                ref={this.doclist}
                documents={user.documents}
                editable={edit || create}
                handleChange={this.handleChange}
              />

              {(edit || create) && (
                <Fragment>
                  {displayErrorContext(errors)}

                  {this.state.pwdError && (
                    <small className="error-context">
                      Les mots de passe doivent être identiques
                    </small>
                  )}

                  <div className="buttons">
                    <Button type="link" onClick={() => history.goBack()}>
                      Annuler
                    </Button>
                    <Button
                      type="primary"
                      disabled={edit && !this.state.edited}
                      onClick={() => this.handleSubmit()}
                    >
                      {edit ? "Enregistrer les changements" : "Créer l'utilisateur"}
                    </Button>
                  </div>

                  <Prompt
                    when={this.state.edited}
                    message="Attention, certaines de vos modifications n'ont pas été enregistrées. Voulez-vous vraiment quitter cette page ?"
                  />
                </Fragment>
              )}

              {!edit && !create && (
                <div className="buttons">
                  <Button
                    type="primary"
                    onClick={() => history.push("/users/" + user.id + "/edit")}
                  >
                    Éditer cet utilisateur
                  </Button>
                </div>
              )}

              <Modal
                className="terms-modal"
                title="Termes et conditions"
                centered
                visible={this.state.termsModal}
                onOk={this.toggleTermsModal}
                onCancel={this.toggleTermsModal}
                footer={null}
              >
                <div>
                  <b>1)</b> L’employé s’engage à respecter les consignes de sécuritéde CLB ainsi que
                  celles du client où il est affecté
                </div>
                <div>
                  <b>2)</b> L’employé confirme être en bonne santé physique
                </div>
                <div>
                  <b>3)</b> L’employé s’engage à:
                  <ul>
                    <li>Respecter les consignes concernant les zones defumage</li>
                    <li>Ne pas travailler sous l’effet de la drogue ou d’alcool</li>
                    <li>Maintenir une bonne ambiance de travail avec lesautres travailleurs</li>
                    <li>
                      Fournir les outils minimum tel que décret (ex.charpentier menuisier :{" "}
                      <i>
                        Sac à clous; Marteau; Ruban à mesurer 25 pieds, système anglais etmétrique;
                        Niveau 24 pouces; Poinçon; Coffre à outils; Pince universelle; Ligne à
                        craie; Ensemble de ciseaux à bois; Couteau à gypse; Passe-partout;
                        Agrafeuse; Ciseau à tôle; Barre à clou; Ensemble de tournevis; Grande
                        équerre; Équerre triangulaire
                      </i>
                      )
                    </li>
                    <li>
                      L’usage du cellulaire ou autre appareil électronique nesont pas permis sur les
                      lieux de travail, sauf dans lessalles de pause
                    </li>
                  </ul>
                </div>
                <div>
                  <b>4)</b> L’employé comprend que le harcèlement et/oul’intimidation ne sont pas
                  tolérés par CLB
                </div>
                <div>
                  <b>5)</b> La prise de photos et la publication de celles-ci sontinterdites sans
                  l’autorisation écrite de CLB et/ou du clien
                </div>
              </Modal>
            </Spin>
          </Can>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.user.infos || {},
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    update: (user) => dispatch(userActions.update(user)),
    updateProfilePicture: (doc) => dispatch(userActions.updateProfilePicture(doc)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserPage);
